import { Http } from "../utils/http.js";

export class DocCenterService {
  retrieveDocumentCenterList(mode, cPage, recPerPage) {
    var url = "document-center/list";
    var docCenterParam = {};
    if (mode === "PIN") {
      docCenterParam = { isPin: "Y" };
    } else if (mode === "PROMO") {
      docCenterParam = { isPromo: "Y" };
    }

    var postData = {
      pageableParameter: {
        pageNumber: cPage,
        pageSize: recPerPage,
        orderBy: "updatedDate",
        orderSequence: "desc",
      },
      documentCenterParameter: docCenterParam,
    };

    return new Http().post(url, postData);
  }

  deleteDocumentCenterList(id) {
    var url = "document-center";

    var postData = {
      documentCenterParameter: {
        documentCenterId: id,
      },
      availabilityParameter: {
        availability: "delete",
      },
    };

    return new Http().post(url, postData);
  }

  retrieveDocumentCenterListByPostdata(postData) {
    if (
      postData.documentCenterParameter.visibilityList.length !== 0 &&
      !postData.documentCenterParameter.visibilityList.includes("ALL")
    ) {
      postData.documentCenterParameter.visibilityList.push("ALL");
    }

    var url = "document-center/list";
    return new Http().post(url, postData);
  }

  retrieveBrokerList() {
    var url = "broker/list";
    var postData = {};
    return new Http().post(url, postData);
  }

  retrieveVisibility(id) {
    var url = "document-center/visibility/list";
    var postData = {
      documentCenterParameter: {
        documentCenterId: id,
      },
    };
    return new Http().post(url, postData);
  }

  createDocCenter(
    id,
    status,
    values,
    selectedMainCategory,
    selectedSubCategory,
    fileId1,
    fileId2,
    fileId3,
    isPin,
    isPromo,
    IFACA,
    selected
  ) {
    var url = "document-center";
    var postData = {
      documentCenterParameter: {
        documentCenterId: id,
        titleEng: values.titleEnglish,
        titleHk: values.titleTraditionalChinese,
        titleCn: values.titleSimplifiedChinese,
        documentStatus: "",
        mainCategoryId: selectedMainCategory,
        subCategoryId: selectedSubCategory,
        descriptionEng: values.descriptionEnglish,
        descriptionHk: values.descriptionTraditionalChinese,
        descriptionCn: values.descriptionSimplifiedChinese,
        file1Id: fileId1,
        file2Id: fileId2,
        file3Id: fileId3,
        effectiveDateFrom: values.effectiveDateFrom,
        effectiveDateTo:
          values.effectiveDateTo === "" ? "2099-12-31" : values.effectiveDateTo,
        isPin: isPin ? "Y" : "N",
        isPromo: isPromo ? "Y" : "N",
        ifaCaIndicator: IFACA,
        visibilityList: selected,
      },
      availabilityParameter: {
        availability: status,
      },
    };
    return new Http().post(url, postData);
  }
}
